import CardHead from "../cardHead";
import PricePanel from "../pricePanel";
import eth from "@assets/rETH.svg";
import rfis from "@assets/rFIS.svg";
import atom from "@assets/rATOM.svg";
import swth from "@assets/rSWTH.svg";
import sei from "@assets/rSEI.svg";
import dot from "@assets/rDOT.svg";
import bnb from "@assets/rBNB.svg";
import matic from "@assets/rMATIC.svg";
import ksm from "@assets/rKSM.svg";
import Item from "./item";
import sol from "@assets/rSOL.svg";
import iris from "@assets/rIRIS.svg";
import huahua from "@assets/rHUAHUA.svg";
import "./index.scss";
import { useEffect, useState } from "react";
import { getDailyincome } from "@/api";
import LoadingOutlined from "../loadingOutlined";
import { formatNumber } from "@/tool/utils";
export default function Index() {
  const [data, setData] = useState<any[]>([]);
  const [fis, setFis] = useState<any>();

  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    getDailyincome()
      .then((res) => {
        if (res.data.status == "80000") {
          const obj = res.data.data;
          const list = res.data.data.map((item: any) => {
            if (item.rsymbol == "rFIS") {
              item.icon = rfis;
            } else if (item.rsymbol == "rETH") {
              item.icon = eth;
            } else if (item.rsymbol == "rDOT") {
              item.icon = dot;
            } else if (item.rsymbol == "rKSM") {
              item.icon = ksm;
            } else if (item.rsymbol == "rATOM") {
              item.icon = atom;
            } else if (item.rsymbol == "rMATIC") {
              item.icon = matic;
            } else if (item.rsymbol == "rBNB") {
              item.icon = bnb;
            } else if (item.rsymbol == "rSOL") {
              item.icon = sol;
            } else if (item.rsymbol == "rIRIS") {
              item.icon = iris;
            } else if (item.rsymbol == "rHUAHUA") {
              item.icon = huahua;
            } else if (item.rsymbol == "rSWTH") {
              item.icon = swth;
            } else if (item.rsymbol == "rSEI") {
              item.icon = sei;
            }
            return item;
          });
          setData(list);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="card-item-Container dailyInComeContainer">
      <CardHead
        title="Daily Income"
        tips="The amount of rTokens received each day."
      />
      <div className="card-item-content">
        <LoadingOutlined spin={loading}>
          {/* <PricePanel color='blue' text={`rFIS = ${fis?.amount} `} /> */}
          {data.map((item) => {
            return (
              <Item
                key={item.rsymbol}
                title={item.rsymbol}
                icon={item.icon}
                value={formatNumber(item.amount, { decimals: 2 })}
              />
            );
          })}
        </LoadingOutlined>
      </div>
    </div>
  );
}
